import styled from 'styled-components';

import { StatusInfoModal } from '../../../StatusInfoModal';

export const StyledStatusInfoModal = styled(StatusInfoModal)`
    width: 100%;
    background: transparent;
    border: none;
    padding: 0;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 1rem;
`;
